<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-form v-bind="this.$attrs">
        <v-row>
          <v-col cols="12" sm="12" md="8">
            <v-row>
              <v-col cols="4">
                <AutocompleteSchoolYear :defaultYear="defaultYear.id" @change="change" />
              </v-col>
              <v-col cols="4">
                <v-select
                  :items="filteredLevelOptions"
                  v-model="academicLevel"
                  label="Cấp"
                  item-value="value"
                  item-text="name"
                  outlined
                  dense
                  hide-details
                />
              </v-col>
              <v-col cols="4">
                <v-select
                  :items="filteredGradeOptions"
                  v-model="grade"
                  label="Khối"
                  item-value="value"
                  item-text="name"
                  outlined
                  dense
                  hide-details
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="4">
            <div class="d-flex justify-end">
              <v-btn
                class="search-button"
                :class="{ 'px-2': windowWidth < 1100 }"
                @click="onFilterChanged"
                outlined
                :disabled="!grade"
              >
                Tìm kiếm
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { uniq, get } from 'lodash'
import AutocompleteSchoolYear from '@/components/basic/input/AutocompleteSchoolYear.vue'

export default {
  components: { AutocompleteSchoolYear },
  data: () => ({
    show: false,
    status: 'active',
    title: '',
    code: '',
    subjectGroup: '',
    academicLevel: '',
    grade: '',
    windowWidth: window.innerWidth,
    levelOptions: [
      { name: 'Cấp 2', value: 'secondary' },
      { name: 'Cấp 3', value: 'high' }
    ],
    gradeOptions: [
      { name: 'Khối 6', value: '6', level: 'secondary' },
      { name: 'Khối 7', value: '7', level: 'secondary' },
      { name: 'Khối 8', value: '8', level: 'secondary' },
      { name: 'Khối 9', value: '9', level: 'secondary' },
      { name: 'Khối 10', value: '10', level: 'high' },
      { name: 'Khối 11', value: '11', level: 'high' },
      { name: 'Khối 12', value: '12', level: 'high' }
    ],
    defaultYear: {},
    schoolYear: null
  }),
  props: {
    defaultFilters: Object
  },
  computed: {
    ...mapState('constant', ['studentStatus']),
    ...mapState('grade', ['query']),
    ...mapState('auth', ['role', 'profile']),
    ...mapState('app', ['currentSchoolYear']),
    filteredLevelOptions() {
      if (this.role.type === 'teacher') {
        const allowedGrades = uniq(this.profile.ownClasses.map(x => x.gradeNumber.toString()))
        const matchedLevels = uniq(this.gradeOptions.filter(x => allowedGrades.includes(x.value)).map(x => x.level))
        return this.levelOptions.filter(x => matchedLevels.includes(x.value))
      }
      return this.levelOptions
    },
    filteredGradeOptions() {
      if (this.role.type === 'teacher') {
        const allowedGrades = this.profile.ownClasses.map(x => x.gradeNumber.toString())
        return this.gradeOptions.filter(x => allowedGrades.includes(x.value))
      }
      return this.gradeOptions
    }
  },
  watch: {
    academicLevel(newVal) {
      if (newVal) {
        const selectedGrade = this.gradeOptions.find(grade => grade.value === this.grade)
        if (selectedGrade && selectedGrade.level !== newVal) {
          this.grade = ''
        }
      }
    },
    grade(newVal) {
      if (newVal) {
        const selectedGrade = this.gradeOptions.find(grade => grade.value === newVal)
        if (selectedGrade && selectedGrade.level !== this.academicLevel) {
          this.academicLevel = selectedGrade.level
        }
      }
    }
  },
  methods: {
    ...mapMutations({ setSchoolYearId: 'teacherDoc/setSchoolYearId' }),
    onFilterChanged() {
      const query = {
        grade: this.grade,
        schoolYear: this.schoolYear
      }
      this.setSchoolYearId(this.schoolYear)
      this.$emit('onFilterChanged', query)
    },
    onResize() {
      this.windowWidth = window.innerWidth
    },
    change(data) {
      this.schoolYear = data
    }
  },
  mounted() {
    if (get(this.currentSchoolYear, 'id')) {
      this.defaultYear = this.currentSchoolYear
      this.schoolYear = get(this.currentSchoolYear, 'id', null)
    }
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  }
}
</script>
<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
}
</style>
